<template>
	<div v-if="!isMultiple" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:is-sequence="!!sequence"
						:max-count="maxCount"
						:expression="expression"
						:sl-attribute="false"
						:enable-copy-attribute-name="enableCopyAttributeName"
						:locked-edit="lockedEdit"
						:rich-text="hasFormatRichText"
						@recalculate="recalculateAttribute"
						@rich-text-handler="richTextHandler"
					/>
				</div>
				<template v-if="hasFormatRichText">
					<div class="col-sm-7">
						<div class="rich-text-view">
							<div class="rich-text-editor-default" v-html="attributeValue"/>
							<input type="hidden" :id="attributeName" :value="attributeValue">
						</div>
						<button v-if="!lockedEdit" class="rich-text-editor-reset fa fa-times" @click="resetRichTextEditor"/>
					</div>
				</template>
				<template v-else>
					<div class="col-sm-7" v-if="maxLength > 150">
						<textarea :class="'textarea attribute-editor ' + getDefaultValueWithLockClasses()"
							  :id="attributeName"
                v-model="attributeValue"
							  :disabled="lockedEdit"/>
						<button v-if="!lockedEdit" class="button_reset single-area-reset fa fa-times"/>
					</div>
					<div class="col-sm-7" v-else>
						<input type="text" :id="attributeName"
							   :class="'textInput attribute-editor ' + getDefaultValueWithLockClasses()"
							   :maxlength="maxLength"
							   v-model="attributeValue"
							   :disabled="lockedEdit">
						<button v-if="!lockedEdit" :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"/>
					</div>
				</template>
			</div>
		</div>
	</div>
	<div v-else data-attribute-type="single" :class="getColumnClass() + ' col-sm-7'">
		<div v-for="(value, key) in attributeValue" :key="key" :data-attribute-index="key">
			<div :class="SINGLE_ATTRIBUTE">
				<div v-if="maxLength > 100">
					<textarea :class="'textarea attribute-editor multiple-hotkey ' + getDefaultValueWithLockClasses()"
							  :id="attributeName + '__' + key"
							  :maxlength="maxLength"
							  v-model="attributeValue[key]"
							  :disabled="lockedEdit"/>
					<button v-if="!lockedEdit" class="button_reset multiple-area-reset fa fa-times"/>
					<button v-if="!lockedEdit" class="button_minus fa fa-minus right-float-button" tabindex="-1" @click="deleteAttribute"/>
				</div>
				<div v-else>
					<input type="text" :id="attributeName + '__' + key"
						   :class="'textInput attribute-editor multiple-hotkey ' + getDefaultValueWithLockClasses()"
						   :maxlength="maxLength"
						   v-model="attributeValue[key]"
						   :disabled="lockedEdit">
					<button v-if="!lockedEdit" :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"/>
					<button v-if="!lockedEdit" class="button_minus fa fa-minus right-float-button" tabindex="-1" @click="deleteAttribute"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { expressionCalculate } from '@/mixins/expressionCalculate'
import { showMessageAlert } from '@/core/shared'
import { richTextEditor } from 'utils/rich-text-editor'
import { UPDATE_ITEM_DATA } from 'actions/configurations'

export default {
	components: {
		AttributeLabel
	},
	mixins: [defaultClassManager, expressionCalculate],
	name: 'SAttributeEditorComponent',
	props: [
		'attributeName',
		'isPrimary',
		'enableCopyAttributeName',
		'itemConfig',
		'lockedEdit'
	],
	data () {
		return {
			SINGLE_ATTRIBUTE: 'single-attribute',
      attributeValue: null
		}
	},
	computed: {
		isCreatePage () {
			return this.$store.state.configurations.isCreatePage
		},
		localizedTitle () {
			return String(this.itemConfig.title)
		},
		isMultiple () {
			return this.itemConfig.multiple
		},
		maxLength () {
			return this.itemConfig.maxLength
		},
		maxCount () {
			return this.itemConfig.maxCount
		},
		defaultValue () {
			return this.itemConfig.defaultValue
		},
		defaultLock () {
			return this.itemConfig.defaultLock
		},
		colspan () {
			return this.itemConfig.colspan
		},
		expression () {
			return this.itemConfig.expression
		},
		sequence () {
			return this.itemConfig.sequence
		},
		hasFormatRichText () {
			return this.itemConfig.format === 'RICH_TEXT'
		},
		type () {
			return this.itemConfig.type
		},
    itemData: function () {
      return this.$store.getters.getItemData
    },
	},
  watch: {
    attributeValue: function (newValue) {
      this.$set(this.itemData, this.attributeName, newValue)
      this.$store.dispatch(UPDATE_ITEM_DATA, this.itemData).then(() => {})
    }
  },
	methods: {
		richTextHandler () {
			richTextEditor(this)
		},
		resetRichTextEditor () {
			if (this.itemData && !this.attributeValue) {
				this.$el.getElementsByClassName('rich-text-editor-default')[0].innerText = ""
				this.$el.getElementsByTagName('input')[0].value = ""
			} else if (this.itemData) {
				this.$set(this.itemData, this.attributeName, '')
				this.attributeChangesRegister()
			}
		},
		deleteAttribute: function (e) {
			let key = $(e.target).parent().parent().parent().attr('data-attribute-index')
			if (key > 0) {
				this.$delete(this.itemData[this.attributeName], key)
				this.attributeChangesRegister()
			}
		},
		attributeChangesRegister () {
			this.$nextTick(() => {
				attributeChangesRegister(this.attributeName)
			})
		},
    getAttributeValue: function () {
      if (this.itemData[this.attributeName]) {
        return this.itemData[this.attributeName]
      } else if (this.defaultValue) {
        return this.defaultValue
      } else {
        return !this.isMultiple ? '' : ['']
      }
    }
	},
	created () {
		if (this.isCreatePage && this.sequence) {
			this.$store.dispatch('NEXT_VALUE', this.sequence).then(value => {
        this.attributeValue = value
        this.$set(this.itemData, this.attributeName, value)
				showMessageAlert(this.$t('attribute.generated', [this.$t(this.localizedTitle)]), 'success')
			})
		}
	},
  mounted () {
    this.attributeValue = this.getAttributeValue();
  }
}
</script>

<style scoped>
</style>
